<template>
  <div class="card">
    <div class="card-header pb-0">
      <div class="float-start">
        <h6>Use case table</h6>
      </div>
      <div class="float-end">
        <div class="row">
          <div class="col-4">
            <select name="pagesx" id="pagesx" v-model="pages" @change="changepages" class="form-select form-select-sm">
              <option value="all">All</option>
              <option value="home">Home</option>
              <option value="solution">Solution</option>
              <option value="advisory">Advisory</option>
              <option value="bom">BOM</option>
            </select>
          </div>

          <div class="col-4">
            <div class="input-group mb-3">
              <input type="search" class="form-control form-control-sm" placeholder="Cari title disini..." id="cari"
                name="cari" v-model="searchQuery" aria-label="Recipient's username" aria-describedby="cari" />
              <button class="btn btn-outline-secondary btn-sm" style="margin-bottom: 0%" type="button" id="cari"
                @click="cari">
                <i class="fas fa-search"></i>
              </button>
            </div>
          </div>
          <div class="col-4">
            <!-- Button to open the modal -->
            <button class="btn btn-sm btn-dark me-2" @click="showModal = true">
              <i class="fa fa-plus"></i> Add use case
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="card-body px-0 pt-0 pb-2">
      <argon-alert v-if="alertstatus != null" :color="alertstatus">
        <strong>{{ alertstatus }}</strong> {{ alerttext }}
      </argon-alert>
      <div class="table-responsive p-0">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                Cover
              </th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                Title
              </th>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                Detail
              </th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            <!-- Loop through banner_list and populate rows -->
            <tr v-for="(item, index) in paginatedData" :key="index">
              <td>
                <div class="btn-group me-4">
                  <button @click="moveUp(index, item.id)" :disabled="index === 0" class="btn btn-outline-primary btn-sm">
                    <i class="fas fa-arrow-up"></i> Move Up
                  </button>
                  <button @click="moveDown(index,  item.id)" :disabled="index === paginatedData.length - 1"
                    class="btn btn-outline-danger btn-sm">
                    <i class="fas fa-arrow-down"></i> Move Down
                  </button>
                </div>

                <img :src="item.cover" alt="cover" style="width: 100px; height: auto" />
              </td>
              <td>{{ item.title }}</td>
              <td>
                <div class="row">
                  <div class="col-sm text-center" v-for="(detail, idx) in item.use_case_detail_data" :key="idx">
                    <div class="card">
                      <div class="card-body">
                        <img :src="detail?.file" alt="cover" class="img-fluid" style="width: 100px; height: auto"
                          v-if="detail.file" />
                        <div class="container" v-if="
                          item?.option_content_page == '1' ||
                          item?.option_content_page == '2'
                        ">
                          <div v-html="truncateHTML(detail?.description, 50)"></div>
                        </div>
                        <div class="container" v-if="item?.option_content_page == '3'">
                          <div v-html="truncateHTML(detail?.content, 50)"></div>
                        </div>
                        <div class="container" v-if="item?.option_content_page == '4'">
                          <div v-html="truncateHTML(detail?.content, 50)"></div>
                          <h6>Location : {{ detail?.location }}</h6>
                          <h6>Industry : {{ detail?.industry }}</h6>
                          <h6>Use case : {{ detail?.use_case }}</h6>
                          <h6>
                            Size of company : {{ detail?.size_of_company }}
                          </h6>
                          <h6>
                            Number of happy : {{ detail?.number_of_happy }}
                          </h6>
                        </div>
                      </div>
                      <div class="card-footer" style="padding: 0%">
                        <button type="button" class="btn btn-sm btn-primary"
                          @click="editdetail(detail, item?.option_content_page)">
                          <i class="fa fa-edit"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
              <td class="text-center">
                <!-- Action buttons (like edit/delete) can go here -->
                <button type="button" class="btn btn-sm btn-primary me-2" @click="edit(item)">
                  <i class="fa fa-edit"></i>
                </button>
                <button type="button" class="btn btn-sm btn-danger" @click="hapus(item?.id)">
                  <i class="fa fa-trash"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-center">
        <argon-pagination>
          <!-- Previous Page Button -->
          <argon-pagination-item prev :disabled="currentPage === 1" @click="prevPage" />

          <!-- Page Numbers -->
          <argon-pagination-item v-for="page in totalPages" :key="page" :label="String(page)"
            :active="currentPage === page" @click="setPage(page)" />

          <!-- Next Page Button -->
          <argon-pagination-item next :disabled="currentPage === totalPages" @click="nextPage" />
        </argon-pagination>
      </div>

      <div :class="showModal == true ? 'modal-backdrop' : ''"></div>
      <div class="modal fade" :class="showModal == true ? 'show' : ''" tabindex="-1" aria-labelledby="modalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered custom-width-modal">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="modalLabel" v-if="method == 'add'">
                Add New use case 
              </h5>
              <h5 class="modal-title" id="modalLabel" v-else>Edit use case </h5>
              <button type="button" class="btn btn-secondary btn-sm" @click="closeModal">
                X
              </button>
            </div>
            <div class="modal-body">
              <form @submit.prevent="submitForm">
                <div class="mb-3" v-if="method != 'editdetail'">
                  <label for="title" class="form-label">Title</label>
                  <input type="text" class="form-control" v-model="formData.title" id="title" required />
                </div>
                <div class="mb-3" v-if="method != 'editdetail'">
                  <label for="cover" class="form-label">Cover</label>
                  <input type="file" ref="coverRef" class="form-control" @change="handleFileUploadCover" :required="method === 'add'"
                    accept="image/*" />
                  <div v-if="imgreview" class="m-4">
                    <img :src="imgreview" alt="" srcset="" style="max-height: 100px" />
                  </div>
                </div>

                <div class="mb-3"  v-if="method === 'add'">
                  <label for="pages" class="form-label" >Pages</label>
                  <select name="pages" id="pages" v-model="formData.pages" @change="handlePages" class="form-select">
                    <option value="all">All</option>
                    <option value="home">Home</option>
                    <option value="solution">Solution</option>
                    <option value="advisory">Advisory</option>
                    <option value="bom">BOM</option>
                  </select>
                </div>
                <div class="mb-3" v-if="method === 'add'">
                  <label for="option_content" class="form-label">Option Content</label>
                  <select name="option_content" id="option_content" v-model="formData.optioncontent"
                    class="form-select">
                    <option value="1">Option 1</option>
                    <option value="2">Option 2</option>
                    <option value="3">Option 3</option>
                    <option value="4">Option 4</option>
                  </select>
                </div>
                <div class="mb-3" v-if="method != 'editdetail'">
                  <label for="option_content" class="form-label">Pilih Icon</label>
                  <div class="icon-radio-group">
                    <label v-for="(icon, idx) in iconList" :key="idx" class="icon-radio">
                      <input type="radio" :value="icon.icon" v-model="formData.icon" />
                      <img :src="icon.icon" :alt="icon.name" class="icon-image" />
                      <span>{{ icon.name }}</span>
                    </label>
                  </div>

                  <!-- Pratinjau Ikon yang Dipilih -->
                  <div class="mt-2">
                    <p>Ikon Terpilih:</p>
                    <img :src="formData.icon" alt="Selected Icon" v-if="formData.icon"
                      style="width: 40px; height: 40px" />
                  </div>
                </div>

                <div class="mb-3" v-if="method != 'editdetail'">
                  <label for="option_content" class="form-label">Deskripsi</label>
                  
                  <QuillEditor ref="descriptionRef" theme="snow" v-model:content="formData.desciptioncontent" contentType="html"
                    class="large-editor" :modules="modules" toolbar="full" />
                  <small class="text-danger">*Tambahkan https:// jika itu link</small>
                </div>

                <div class="mb-3"  v-if="method != 'editdetail'">
                  <label for="is_active" class="form-label">Status</label>
                  <select name="is_active" id="is_active" class="form-select" v-model="formData.is_active">
                    <option :value="true">Active
                    </option>
                    <option :value="false">Inactive
                    </option>
                  </select>
                </div>

                <hr />
                <div v-if="method == 'add'">
                  <div v-if="
                    formData.optioncontent == '1' ||
                    formData.optioncontent == '2'
                  ">
                    <div v-for="(item, index) in jmldetail" :key="index">
                      <div class="mb-3" v-if="method == 'add'">
                        <label for="deskripsi" class="form-label">Deskripsi {{ index + 1 }}</label>
                        <QuillEditor theme="snow" v-model:content="formData.desciption[index]" contentType="html"
                          class="large-editor" :modules="modules" toolbar="full" />
                        <small class="text-danger">*Tambahkan https:// jika itu link</small>
                      </div>
                      <div class="mb-3" v-if="method == 'add' || method == 'editdetail'">
                        <label for="file" class="form-label">File {{ index + 1 }}</label>
                        <input type="file" class="form-control" @change="handleFileUpload($event, index)"
                          :required="method === 'add'" accept="image/*" v-if="method == 'add'" />
                        <input type="file" class="form-control" @change="handleFileUploaddetail"
                          :required="method === 'add'" accept="image/*" v-if="method == 'editdetail'" />
                        <small class="text-danger">*Max resolusi 1080x607 (Rekomendasi)</small>
                      </div>
                      <div class="mb-3" v-if="method == 'editdetail'">
                        <label for="deskripsi" class="form-label">Deskripsi</label>
                        <QuillEditor theme="snow" v-model:content="formData.desciption" contentType="html"
                          class="large-editor" :modules="modules" toolbar="full" />
                        <small class="text-danger">*Tambahkan https:// jika itu link</small>
                      </div>
                      <!-- Remove Button -->
                      <div class="text-end" v-if="index >= 1">
                        <button type="button" class="btn btn-sm btn-danger" @click="removeDetail(index)">
                          <i class="fas fa-minus"></i> Remove
                        </button>
                      </div>
                    </div>
                    <!-- Add Button -->
                    <div v-if="method == 'add'">
                      <button type="button" class="btn btn-sm btn-success" @click="addDetail">
                        <i class="fas fa-plus"></i> Add
                      </button>
                    </div>
                  </div>
                  <div v-else-if="formData.optioncontent == '3'">
                    <div class="mb-3">
                      <label for="deskripsicontent" class="form-label">Deskripsi Content</label>
                      <QuillEditor theme="snow" v-model:content="formData.content" contentType="html"
                        class="large-editor" id="deskripsicontent" :modules="modules" toolbar="full" />
                      <small class="text-danger">*Tambahkan https:// jika itu link</small>
                    </div>
                  </div>
                  <div v-else-if="formData.optioncontent == '4'">
                    <div class="mb-3">
                      <label for="deskripsicontent4" class="form-label">Deskripsi Content</label>
                      <QuillEditor theme="snow" v-model:content="formData.content" contentType="html"
                        class="large-editor" id="deskripsicontent4" :modules="modules" toolbar="full" />
                      <small class="text-danger">*Tambahkan https:// jika itu link</small>
                    </div>
                    <div class="mb-3">
                      <label for="logo" class="form-label">Logo</label>
                      <input type="file" class="form-control" @change="handleFileUploadlogo"
                        :required="method === 'add'" accept="image/*" />

                      <div v-if="logoPreview" class="m-4">
                        <img :src="logoPreview" alt="" srcset="" style="max-height: 100px" />
                      </div>
                    </div>
                    <div class="mb-3">
                      <label for="location">Location</label>
                      <input type="text" class="form-control" v-model="formData.location" id="location" required />
                    </div>
                    <div class="mb-3">
                      <label for="industry">Industry</label>
                      <input type="text" class="form-control" v-model="formData.industry" id="industry" required />
                    </div>
                    <div class="mb-3">
                      <label for="use_case">Use case</label>
                      <input type="text" class="form-control" v-model="formData.use_case" id="use_case" required />
                    </div>
                    <div class="mb-3">
                      <label for="size_of_company">Size of company</label>
                      <input type="text" class="form-control" v-model="formData.size_of_company" id="size_of_company"
                        required @keypress="validateInput($event)" />
                    </div>
                    <div class="mb-3">
                      <label for="number_of_happy">Number of happy</label>
                      <input type="text" class="form-control" v-model="formData.number_of_happy" id="number_of_happy"
                        required @keypress="validateInput($event)" />
                    </div>
                    <hr />
                    <div v-for="(item, index) in jmldetailicon" :key="index">
                      <div class="mb-3" v-if="method == 'add'">
                        <label for="title" class="form-label">Title {{ index + 1 }}</label>
                        <input type="text" class="form-control" v-model="formData.journeytitle[index]" required />
                      </div>
                      <div class="mb-3" v-if="method == 'add'">
                        <label for="number" class="form-label">Number {{ index + 1 }}</label>
                        <input type="text" class="form-control" v-model="formData.journeynumber[index]" required
                          @keypress="validateInput($event)" />
                      </div>
                      <div class="mb-3" v-if="method == 'add'">
                        <label for="icon" class="form-label">Icon {{ index + 1 }}</label>
                        <input type="text" class="form-control" v-model="formData.journeyicon[index]" required
                          readonly />
                        <label for="option_content" class="form-label">Pilih Icon</label>
                        <div class="icon-radio-group">
                          <label v-for="(icon, idx) in iconList" :key="idx" class="icon-radio">
                            <input type="radio" :value="icon.icon" v-model="formData.journeyicon[index]" />
                            <img :src="icon.icon" :alt="icon.name" class="icon-image" />
                            <span>{{ icon.name }}</span>
                          </label>
                        </div>

                        <!-- Pratinjau Ikon yang Dipilih -->
                        <div class="mt-2">
                          <p>Ikon Terpilih:</p>
                          <img :src="formData.journeyicon[index]" alt="Selected Icon" v-if="formData.journeyicon[index]"
                            style="width: 40px; height: 40px" />
                        </div>
                      </div>
                      <!-- Remove Button -->
                      <div class="text-end" v-if="index >= 1">
                        <button type="button" class="btn btn-sm btn-danger" @click="removeDetailicon(index)">
                          <i class="fas fa-minus"></i> Remove
                        </button>
                      </div>
                    </div>
                    <!-- Add Button -->
                    <div v-if="jmldetailicon.length < 4">
                      <button type="button" class="btn btn-sm btn-success" @click="addDetailicon">
                        <i class="fas fa-plus"></i> Add
                      </button>
                    </div>

                    <div v-for="(item, index) in bannerslider" :key="index">
                      <div class="mb-3">
                        <label for="title" class="form-label">Title Banner{{ index + 1 }}</label>
                        <input type="text" class="form-control" v-model="formData.banner_title[index]" required />
                      </div>
                      <div class="mb-3">
                        <label for="img" class="form-label">File Banner</label>
                        <input type="file" id="img" class="form-control" @change="handleFileUploadbanner($event, index)"
                          :required="method === 'add'" accept="image/*" v-if="method != 'edit'" />
                        <div v-if="bannerPreview[index]" class="m-4">
                          <img :src="bannerPreview[index]" alt="" srcset="" style="max-height: 100px" />
                        </div>
                      </div>
                      <!-- Remove Button -->
                      <div class="text-end" v-if="index >= 1">
                        <button type="button" class="btn btn-sm btn-danger" @click="removebanner(index)">
                          <i class="fas fa-minus"></i> Remove Banner
                        </button>
                      </div>
                    </div>
                    <div v-if="method == 'add'">
                      <button type="button" class="btn btn-sm btn-success" @click="addbanner">
                        <i class="fas fa-plus"></i> Add Banner
                      </button>
                    </div>
                  </div>
                </div>

                <div v-else>
                  <div v-if="optionselect == 1 || optionselect == 2">
                    <div class="mb-3" v-if="method == 'editdetail'">
                      <label for="deskripsi" class="form-label">Deskripsi</label>
                      <QuillEditor theme="snow" v-model:content="formData.desciption" contentType="html"
                        class="large-editor" :modules="modules" toolbar="full" />
                      <small class="text-danger">*Tambahkan https:// jika itu link</small>
                    </div>
                    <div class="mb-3" v-if="method == 'add' || method == 'editdetail'">
                      <label for="file" class="form-label">File</label>
                      <input type="file" class="form-control" @change="handleFileUpload($event, index)"
                        :required="method === 'add'" accept="image/*" v-if="method == 'add'" />
                      <input type="file" class="form-control" @change="handleFileUploaddetail" accept="image/*"
                        v-if="method == 'editdetail'" />
                      <div v-if="imgreview" class="m-4">
                        <img :src="imgreview" alt="" srcset="" style="max-height: 100px" />
                      </div>
                    </div>
                  </div>
                  <div v-if="optionselect == 3">
                    <div class="mb-3" v-if="method == 'editdetail'">
                      <label for="deskripsi" class="form-label">Deskripsi</label>
                      <QuillEditor theme="snow" v-model:content="formData.content" contentType="html"
                        class="large-editor" :modules="modules" toolbar="full" />
                      <small class="text-danger">*Tambahkan https:// jika itu link</small>
                    </div>
                  </div>
                  <div v-if="optionselect == 4">
                    <div class="mb-3" v-if="method == 'editdetail'">
                      <label for="deskripsi" class="form-label">Deskripsi</label>
                      <QuillEditor theme="snow" v-model:content="formData.content" contentType="html"
                        class="large-editor" :modules="modules" toolbar="full" />
                      <small class="text-danger">*Tambahkan https:// jika itu link</small>
                    </div>
                    <div class="mb-3">
                      <label for="logo" class="form-label">Logo</label>
                      <input type="file" class="form-control" @change="handleFileUploadlogo"
                        :required="method === 'add'" accept="image/*" />
                      <div v-if="logoPreview" class="m-4">
                        <img :src="logoPreview" alt="" srcset="" style="max-height: 100px" />
                      </div>
                    </div>
                    <div class="mb-3">
                      <label for="location">Location</label>
                      <input type="text" class="form-control" v-model="formData.location" id="location" required />
                    </div>
                    <div class="mb-3">
                      <label for="industry">Industry</label>
                      <input type="text" class="form-control" v-model="formData.industry" id="industry" required />
                    </div>
                    <div class="mb-3">
                      <label for="use_case">Use case</label>
                      <input type="text" class="form-control" v-model="formData.use_case" id="use_case" required />
                    </div>
                    <div class="mb-3">
                      <label for="size_of_company">Size of company</label>
                      <input type="text" class="form-control" v-model="formData.size_of_company" id="size_of_company"
                        required @keypress="validateInput($event)" />
                    </div>
                    <div class="mb-3">
                      <label for="number_of_happy">Number of happy</label>
                      <input type="text" class="form-control" v-model="formData.number_of_happy" id="number_of_happy"
                        required @keypress="validateInput($event)" />
                    </div>

                    <div v-for="(item, index) in journeyData" :key="index">
                      <div class="mb-3">
                        <label for="title" class="form-label">Title {{ index + 1 }}</label>
                        <input type="text" class="form-control" v-model="item.title" required />
                      </div>
                      <div class="mb-3">
                        <label for="number" class="form-label">Number {{ index + 1 }}</label>
                        <input type="text" class="form-control" v-model="item.number" required
                          @keypress="validateInput($event)" />
                      </div>
                      <div class="mb-3">
                        <label for="icon" class="form-label">Icon {{ index + 1 }}</label>
                        <input type="text" class="form-control" v-model="item.icon" required readonly />
                        <label for="option_content" class="form-label">Pilih Icon</label>
                        <div class="icon-radio-group">
                          <label v-for="(icon, idx) in iconList" :key="idx" class="icon-radio">
                            <input type="radio" :value="icon.icon" v-model="item.icon" />
                            <img :src="icon.icon" :alt="icon.name" class="icon-image" />
                            <span>{{ icon.name }}</span>
                          </label>
                        </div>
                        <div class="mt-2">
                          <p>Ikon Terpilih:</p>
                          <img :src="item.icon" alt="Selected Icon" v-if="item.icon"
                            style="width: 40px; height: 40px" />
                        </div>
                      </div>

                      <div class="row">
                        <!-- Remove Button -->
                        <div class="col-sm text-end">
                          <button type="button" class="btn btn-sm btn-danger" @click="removeDetailIcon(item.id, index)">
                            <i class="fas fa-minus"></i> Remove
                          </button>
                        </div>
                        <div class="col-sm text-start">
                          <button type="button" class="btn btn-sm btn-info" @click="updateDetailIcon(item.id, index)">
                            <i class="fas fa-pen"></i> Update
                          </button>
                        </div>
                        <!-- Save Icon Button (Only for New Data) -->
                        <div class="col-sm text-center" v-if="index >= jmljourneyDataold">
                          <button type="button" class="btn btn-primary btn-sm" @click="addicon(item)">
                            <i class="fas fa-save"></i> Save Icon
                          </button>
                        </div>
                      </div>
                    </div>

                    <!-- Add Button -->
                    <div v-if="journeyData.length < 4">
                      <button type="button" class="btn btn-sm btn-success" @click="addDetailiconEdit">
                        <i class="fas fa-plus"></i> Add
                      </button>
                    </div>

                    <div v-for="(item, index) in bannerslider" :key="index">
                      <div class="mb-3">
                        <label for="title" class="form-label">Title Banner{{ index + 1 }}</label>
                        <input type="text" class="form-control" v-model="formData.banner_title[index]" required />
                      </div>
                      <div class="mb-3">
                        <label for="img" class="form-label">File Banner</label>
                        <input type="file" id="img" class="form-control" @change="handleFileUploadbannerEdit($event, item, index)"
                          :required="method === 'add'" accept="image/*" v-if="method != 'edit'" />
                        <div v-if="bannerPreview[index]" class="m-4">
                          <img :src="bannerPreview[index]" alt="" srcset="" style="max-height: 100px" />
                        </div>
                      </div>
                      <!-- Remove Button -->
                      <div class="text-end" v-if="index >= 1">
                        <button type="button" class="btn btn-sm btn-danger" @click="removebanner(index)">
                          <i class="fas fa-minus"></i> Remove Banner
                        </button>
                      </div>
                    </div>
                    <div v-if="method == 'editdetail'">
                      <button type="button" class="btn btn-sm btn-success" @click="addbanner">
                        <i class="fas fa-plus"></i> Add Banner
                      </button>
                    </div>
                  </div>
                </div>

                <div class="text-end">
                  <button type="button" class="btn btn-secondary btn-sm me-2" @click="closeModal">
                    Close
                  </button>
                  <button class="btn btn-primary btn-sm" :disabled="loading">
                    <span v-if="loading" class="spinner-border spinner-border-sm" role="status"
                      aria-hidden="true"></span>
                    <span v-if="!loading">Submit</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import api from "@/utils/api";
import ArgonPagination from "@/components/ArgonPagination.vue";
import ArgonPaginationItem from "@/components/ArgonPaginationItem.vue";
import ArgonAlert from "@/components/ArgonAlert.vue";

import { QuillEditor } from "@vueup/vue-quill";
import "@vueup/vue-quill/dist/vue-quill.snow.css";
import ImageUploader from "quill-image-uploader";

export default {
  data() {
    return {
      loading: false,
      usecaseList: [], // Holds the list of banners
      currentPage: 1, // Track the current page
      cards: [], // card kosong
      totalPages: [], // Total number of pages
      itemsPerPage: 10,
      sortOrder: "asc",
      searchQuery: "",
      pages: "all",
      showModal: false, // Controls modal visibility
      formData: {
        pages: "all",
        title: "",
        cover: null,
        files: [],
        banner: [],
        banner_title: [],
        desciption: [],
        optioncontent: "1",
        icon: "",
        desciptioncontent: "",
        journeyicon: [],
        journeytitle: [],
        journeynumber: [],
        is_active: true,

      },
      method: "add",
      alertstatus: null,
      alerttext: null,
      jmldetail: [{}],
      jmldetailicon: [{}],
      journeyData: [], // Pisahkan journey
      journeyDataold: [],
      jmljourneyDataold: "",
      bannerslider: [{}],
      optionselect: "",
      iconList: [
        { name: "Icon 1", icon: "/icons/01.png" },
        { name: "Icon 2", icon: "/icons/02.png" },
        { name: "Icon 3", icon: "/icons/03.png" },
        { name: "Icon 4", icon: "/icons/04.png" },
        { name: "Icon 5", icon: "/icons/05.png" },
        { name: "Icon 6", icon: "/icons/06.png" },
        { name: "Icon 7", icon: "/icons/07.png" },
        { name: "Icon 8", icon: "/icons/08.png" },
        { name: "Icon 9", icon: "/icons/09.png" },
        { name: "Icon 10", icon: "/icons/10.png" },
        { name: "Icon 11", icon: "/icons/11.png" },
        { name: "Icon 12", icon: "/icons/12.png" },
        { name: "Icon 13", icon: "/icons/13.png" },
        { name: "Icon 14", icon: "/icons/14.png" },
        { name: "Icon 15", icon: "/icons/15.png" },
        { name: "Icon 16", icon: "/icons/16.png" },
        { name: "Icon 17", icon: "/icons/17.png" },
        { name: "Icon 18", icon: "/icons/18.png" },
        { name: "Icon 19", icon: "/icons/19.png" },
        { name: "Icon 20", icon: "/icons/20.png" },
        { name: "Icon 21", icon: "/icons/21.png" },
        { name: "Icon 22", icon: "/icons/22.png" },
        { name: "Icon 23", icon: "/icons/23.png" },
        { name: "Icon 24", icon: "/icons/24.png" },
        { name: "Icon 25", icon: "/icons/25.png" },
      ],
      imgreview: null,
      logoPreview: null,
      bannerPreview: [],
    };
  },
  components: {
    ArgonPagination,
    ArgonPaginationItem,
    ArgonAlert,
    QuillEditor,
  },
  mounted() {
    // Fetch the banner list when the component is mounted
    this.fetchusecaseList();
  },
  computed: {
    totalItems() {
      return this.usecaseList.length;
    },
    paginatedData() {
      return this.usecaseList.slice(0, this.itemsPerPage);
    },
    currentContent() {
      return this.formData?.desciption || this.formData?.content || "";
    },
  },
  setup: () => {
    const modules = {
      name: "imageUploader",
      module: ImageUploader,
      options: {
        upload: (file) => {
          return new Promise((resolve, reject) => {
            const formData = new FormData();
            formData.append("attachment", file);



            // const response = await api.post("/admin/upload/editor/usecase", {...formData}
            // });

            api.post("/admin/upload/editor/usecase", formData, {
              headers: { "Content-Type": "multipart/form-data" },
            })
              .then((res) => {
                console.log(res);
                resolve(res.data.data?.attachment);
              })
              .catch((err) => {
                reject("Upload failed");
                console.error("Error:", err);
              });
          });
        },
      },
    };
    return { modules };
  },
  methods: {
    async fetchusecaseList(sortOrder) {


      try {
        const response = await api.get("admin/use_case", {
          params: {
            sort: sortOrder ? sortOrder : this.sortOrder,
            limit: this.itemsPerPage,
            paginate: this.currentPage,
            key_search: this.searchQuery,
            pages: this.pages,
          }
        });

        if (response.data?.message == "success") {
          this.usecaseList = response.data.data.use_case_list; // Assign banner_list to local data
          this.totalPages = response.data.data.paginate; // Update the total number of pages (this depends on how the API returns pagination info)
        } else {
          this.alertstatus = "danger";
          this.alerttext = "Error get data";
        }

      } catch (error) {
        var err = error.response.data.message;
        this.alertstatus = "danger";
        this.alerttext = err;
        console.error("Error fetching data:", error);
      }


    },
    nextPage() {
      if (this.currentPage < this.totalPages.length) {
        this.currentPage++;
        this.fetchusecaseList();
      }
    },
    prevPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.fetchusecaseList();
      }
    },
    setPage(page) {
      this.currentPage = page;
      this.fetchusecaseList();
    },
    updateItemsPerPage() {
      this.fetchusecaseList();
    },
    updatesoftby() {
      this.fetchusecaseList();
    },
    changepages() {
      console.log(this.pages);
      this.fetchusecaseList();
    },
    cari() {
      this.fetchusecaseList();
    },
    truncateText(text, length) {
      if (text.length > length) {
        return text.slice(0, length) + "...";
      }
      return text;
    },
    truncateHTML(htmlContent, maxLength) {
      const tempElement = document.createElement("div");
      tempElement.innerHTML = htmlContent || "";
      const textContent =
        tempElement.textContent || tempElement.innerText || "";

      // Potong teks jika panjangnya melebihi maxLength
      if (textContent.length > maxLength) {
        return textContent.slice(0, maxLength) + "...";
      }

      return htmlContent;
    },
    handlePages() {
      if (this.formData.pages == "bom") {
        this.jmldetail = 2;
      } else {
        this.jmldetail = 2;
      }
    },
    closeModal() {
      this.showModal = false;

      // Reset form data
      this.file = null
      if (this.$refs.coverRef) {
        this.$refs.coverRef.value = "";
      }
      const editor = this.$refs.descriptionRef
      if (editor) {
        editor.getQuill().setText('') 
      }
      
      this.optionselect = "";
      this.formData = {
        pages: "all",
        title: "",
        cover: null,
        files: [],
        banner: [],
        banner_title: [],
        desciption: [],
        optioncontent: "1",
        icon: "",
        desciptioncontent: "",
        journeyicon: [],
        journeytitle: [],
        journeynumber: [],
      };
      this.jmldetail = [{}];
      this.jmldetailicon = [{}];
      this.journeyData = [];
      this.journeyDataold = [];
      this.jmljourneyDataold = "";
      this.bannerslider = [{}];
      this.imgreview = null;
      this.logoPreview = null;
      this.method = "add";
    },
    handleFileUpload(event, index) {
      const file = event.target.files[0];
      // Make sure the array has the correct length
      if (this.formData.files.length <= index) {
        this.formData.files.splice(index, 0, file);
      } else {
        this.formData.files[index] = file;
      }
      console.log(this.formData.files);
    },
    handleFileUploadbanner(event, index) {
      const file = event.target.files[0];
      // Make sure the array has the correct length
      if (this.formData.banner.length <= index) {
        this.formData.banner.splice(index, 0, file);
        this.bannerPreview.splice(index, 0, URL.createObjectURL(event.target.files[0]));
      } else {
        this.formData.banner[index] = file;
        this.bannerPreview[index] = URL.createObjectURL(event.target.files[0]);
      }
    },
    async handleFileUploadbannerEdit(event, item, index) {
      const data = new FormData();

      if (!item?.id) {
        const file = event.target.files[0];
        if (this.formData.banner.length <= index) {
          this.formData.banner.splice(index, 0, file);
          this.bannerPreview.splice(index, 0, URL.createObjectURL(event.target.files[0]));
        } else {
          this.formData.banner[index] = file;
          this.bannerPreview[index] = URL.createObjectURL(event.target.files[0]);
        }
      } else {

        try {
          data.append('banner', event.target.files[0]);
    
         const response =  await api.put(`/admin/use_case_detail_banner/${item.id}`, data, {
              headers: { "Content-Type": "multipart/form-data" },
            });
  
  
            this.bannerPreview[index] = response?.data?.data;
  
            this.fetchusecaseList();
          
        } catch (error) {
            this.$swal({
            title: error.response.data.message,
            text: 'warning',
            icon: "warning",
            confirmButtonColor: "#3085d6",
          });
        }
      }



    },
    handleFileUploadCover(event) {
      this.formData.cover = event.target.files[0]; // Capture the single cover file
      this.imgreview = URL.createObjectURL(event.target.files[0]); // Buat URL untuk preview gambar
    },
    handleFileUploadlogo(event) {
      this.formData.logo = event.target.files[0]; // Capture the single cover file
      this.logoPreview = URL.createObjectURL(event.target.files[0]);
    },
    handleFileUploaddetail(event) {
      this.formData.files = event.target.files[0]; // Capture the single cover file
      this.imgreview = URL.createObjectURL(event.target.files[0]); // Buat URL untuk preview gambar
    },
    addDetail() {
      this.jmldetail.push({ desciption: "", file: null });
      this.formData.desciption.push(""); // Add an empty description for binding
    },
    removeDetail(index) {
      this.jmldetail.splice(index, 1);
      this.formData.desciption.splice(index, 1); // Remove corresponding description
    },
    addDetailicon() {
      this.jmldetailicon.push({
        journeytitle: "",
        journeynumber: "",
        journeyicon: "",
      });
    },
    removeDetailicon(index) {
      this.jmldetailicon.splice(index, 1);
    },
    addbanner() {
      this.bannerslider.push({ banner_title: "", banner: null });
    },
    removebanner(index) {
      this.bannerslider.splice(index, 1);
      this.formData.banner.splice(index,1);
      this.formData.banner_title.splice(index,1);
      this.formData.banner_id.splice(index,1);

     
    },

    async submitForm() {
      let access_token = localStorage.getItem("access_token");
      const data = new FormData();
      var config = {};

      data.append("is_active", this.formData.is_active);

      if (this.method == "add") {
        data.append("pages", this.formData.pages);
        data.append("title", this.formData.title);
        data.append("icon", this.formData.icon);

        data.append(
          "description_content_pages",
          this.formData.desciptioncontent
        );
        if (this.formData.cover) {
          data.append("cover", this.formData.cover);
        }
        data.append("option_content_page", this.formData.optioncontent);

        if (
          this.formData.optioncontent == "1" ||
          this.formData.optioncontent == "2"
        ) {
          // Tambahkan deskripsi
          this.formData.desciption.forEach((desc, index) => {
            data.append(`description[${index}]`, desc);
          });
          // Append files to FormData
          this.formData.files.forEach((file) => {
            data.append("file", file);
          });
        } else if (this.formData.optioncontent == "3") {
          data.append("content", this.formData.content);
        } else if (this.formData.optioncontent == "4") {
          data.append("content", this.formData.content);
          data.append("logo", this.formData.logo);
          data.append("location", this.formData.location);
          data.append("industry", this.formData.industry);
          data.append("use_case", this.formData.use_case);
          data.append("size_of_company", this.formData.size_of_company);
          data.append("number_of_happy", this.formData.number_of_happy);
          // Tambahkan
          this.formData.journeytitle.forEach((title, index) => {
            data.append(`journey_title[${index}]`, title);
          });
          this.formData.journeynumber.forEach((number, index) => {
            data.append(`journey_number[${index}]`, number);
          });
          this.formData.journeyicon.forEach((icon, index) => {
            data.append(`journey_icon[${index}]`, icon);
          });

          this.formData.banner.forEach((file) => {
            data.append("banner", file);
          });
          this.formData.banner_title.forEach((desc, index) => {
            data.append(`banner_title[${index}]`, desc);
          });
        }

        config = {
          method: "post",
          maxBodyLength: Infinity,
          url: "/admin/use_case",
          headers: {
            Authorization: "Bearer " + access_token, // Replace with the actual token
          },
          data: data,
        };
      } else if (this.method == "edit") {
        data.append("title", this.formData.title);
        data.append(
          "description_content_pages",
          this.formData.desciptioncontent
        );
        data.append("icon", this.formData.icon);
        if (this.formData.cover) {
          data.append("cover", this.formData.cover);
        }

        config = {
          method: "put",
          maxBodyLength: Infinity,
          url:
            "/admin/use_case/" +
            this.formData.optioncontent +
            "/" +
            this.formData.id,
          headers: {
            Authorization: "Bearer " + access_token, // Replace with the actual token
          },
          data: data,
        };
      } else {
        if (this.optionselect == 1 || this.optionselect == 2) {
          data.append("description", this.formData.desciption);
          data.append("file", this.formData.files);
        } else if (this.optionselect == 3) {
          data.append("content", this.formData.content);
        } else if (this.optionselect == 4) {
          data.append("content", this.formData.content);
          data.append("logo", this.formData.logo);
          data.append("location", this.formData.location);
          data.append("industry", this.formData.industry);
          data.append("use_case", this.formData.use_case);
          data.append("size_of_company", this.formData.size_of_company);
          data.append("number_of_happy", this.formData.number_of_happy);

          this.formData.banner.forEach((file) => {
            if (typeof file !=='string') data.append("banner", file);
          });
          this.formData.banner_title.forEach((desc, index) => {
            data.append(`banner_title[${index}]`, desc);
          });
          this.formData.banner_id.forEach((desc, index) => {
            data.append(`banner_id[${index}]`, desc);
          });
        }

        config = {
          method: "put",
          maxBodyLength: Infinity,
          url:
            "/admin/use_case_detail/" +
            this.optionselect +
            "/" +
            this.formData.id,
          headers: {
            Authorization: "Bearer " + access_token, // Replace with the actual token
          },
          data: data,
        };
      }

      try {
        this.loading = true;

        const response = await api[config.method](config.url, data, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        if (response.data?.message == "success") {
          this.fetchusecaseList();
          if (this.method == "add") {
            this.$swal({
              title: "Success!",
              text: "Add data success",
              icon: "success",
            });
          } else {
            this.$swal({
              title: "Success!",
              text: "Edit data success",
              icon: "success",
            });
          }
          // setTimeout(function(){
          //    window.location.reload(1);
          // }, 1500);
          this.closeModal(); // Close modal after successful submission
        } else {
          this.alertstatus = "danger";
          this.alerttext = "Error add data";
        }
        console.log(response.data);
      } catch (error) {
        var err = error.response.data.data

        this.$swal({
          title: error.response.data.message,
          text: err,
          icon: "warning",
          confirmButtonColor: "#3085d6",
        });
      } finally {
        this.loading = false;
      }
    },

    async hapus(id) {
      let access_token = localStorage.getItem("access_token");
      const result = await this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      });

      if (result.isConfirmed) {
        const config = {
          method: "delete", // Ganti ke delete jika API menggunakan method ini
          maxBodyLength: Infinity,
          url: "/admin/use_case/" + id,
          headers: {
            Authorization: "Bearer " + access_token, // Replace with the actual token
          },
        };

        try {
          const response = await api[config.method](config.url);
          if (response.data?.message == "success") {
            await this.fetchusecaseList(); // Refresh banner list after deletion
            this.$swal({
              title: "Deleted!",
              text: "Your data has been deleted.",
              icon: "success",
            });
          } else {
            this.$swal({
              title: "Error!",
              text: "There was an issue deleting the data.",
              icon: "error",
            });
          }
        } catch (error) {
          console.error(error);
          this.$swal({
            title: "Error!",
            text: "Failed to delete the data.",
            icon: "error",
          });
        }
      }
    },

    edit(item) {
      console.log({ item });
      this.formData = {
        title: item?.title,
        icon: item?.icon,
        desciptioncontent: item?.description_content_pages,
        id: item?.id,
        optioncontent: item?.option_content_page,
        is_active: item.is_active,
        pages: item.pages,

        // pages: "all",
        // cover: null,
        files: [],
        banner: [],
        banner_title: [],
        journeyicon: [],
        journeytitle: [],
        journeynumber: [],
      };
      // console.log(this.formData, 'tes')
      this.imgreview = item.cover;
      this.showModal = true;
      this.method = "edit";
    },
    editdetail(item, option) {
      console.log({ item, option })
      this.optionselect = option;
      this.formData = {
        id: item?.id,
        desciption: item?.description,
        files: [],
        content: item?.content,
        logo: item?.logo,
        location: item?.location,
        industry: item?.industry,
        use_case: item?.use_case,
        size_of_company: item?.size_of_company,
        number_of_happy: item?.number_of_happy,
      };
      this.imgreview = item.file;
      if (option == 4) {
        this.journeyDataold = item?.journey_data; // Simpan data journey terpisah
        this.jmljourneyDataold = this.journeyDataold.length;
        this.journeyData = item?.journey_data; // Simpan data journey terpisah
        this.formData.banner = item?.banner_list.map((item) => item.banner);
        this.formData.banner_title = item?.banner_list.map(
          (item) => item.title
        );
        this.formData.banner_id = item?.banner_list.map(
          (item) => item.id
        );
        this.bannerPreview = item?.banner_list.map(item => item.banner);
        this.logoPreview = item?.logo;
        this.bannerslider = item?.banner_list.map(data => {
          return {
            banner_title: data.title, 
            banner: data.banner,
            id: data.id
          }
        })
        // this.bannerslider.push({ banner_title: "", banner: null });
      }

      console.log(this.logoPreview, 'bannerPreview')
      this.showModal = true;
      this.method = "editdetail";
    },
    addDetailiconEdit() {
      this.journeyData.push({
        id: null,
        title: "",
        number: "",
        icon: "",
      });
    },
    async removeDetailIcon(id, index) {
      if (id) {
        let access_token = localStorage.getItem("access_token");
        const result = await this.$swal({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!",
        });

        if (result.isConfirmed) {
          const config = {
            method: "delete", // Ganti ke delete jika API menggunakan method ini
            maxBodyLength: Infinity,
            url:
              "/admin/use_case_journey/" +
              id,
            headers: {
              Authorization: "Bearer " + access_token, // Replace with the actual token
            },
          };

          try {

            const response = await api[config.method](config.url);
            if (response.data?.message == "success") {
              await this.fetchusecaseList(); // Refresh banner list after deletion
              this.$swal({
                title: "Deleted!",
                text: "Your data has been deleted.",
                icon: "success",
              });
              this.closeModal();
              this.journeyData.splice(index, 1);
            } else {
              this.$swal({
                title: "Error!",
                text: "There was an issue deleting the data.",
                icon: "error",
              });
            }
          } catch (error) {
            var err = error.response.data.message;
            this.$swal({
              title: "Error!",
              text: err,
              icon: "error",
            });
          }
        }
      } else {
        this.journeyData.splice(index, 1);
      }
    },
    async updateDetailIcon(id, index) {
      let access_token = localStorage.getItem("access_token");
      const item = this.journeyData[index];

      const formattedData = {
        use_case_detail_data_id: this.formData.id,
        journey_title: item?.title,
        journey_icon: item?.icon,
        journey_number: item?.number,
      };

      const config = {
        method: "put",
        maxBodyLength: Infinity,
        url:
          "/admin/use_case_journey/" +
          item.id,
        headers: {
          Authorization: "Bearer " + access_token, // Replace with the actual token
        },
        data: formattedData,
      };
      try {
        const response = await api[config.method](config.url);

        if (response.data?.message == "success") {
          await this.fetchusecaseList(); // Refresh banner list after deletion
          this.$swal({
            title: "Update",
            text: "Your data has been Update.",
            icon: "success",
          });
          this.closeModal();
        } else {
          this.$swal({
            title: "Error!",
            text: "There was an issue deleting the data.",
            icon: "error",
          });
        }
      } catch (error) {
        var err = error.response.data.message;
        this.$swal({
          title: "Error!",
          text: err,
          icon: "error",
        });
      }
    },
    async addicon(item) {
      let access_token = localStorage.getItem("access_token");
      // Ambil hanya data yang baru berdasarkan ID
      // const newItems = this.journeyData.filter(item =>
      //     !this.journeyDataold.some(oldItem => oldItem.id === item.id)
      // );

      const formattedData = [
        {
          journey_title: item.title,
          journey_icon: item.icon,
          journey_number: item.number,
        },
      ];
      console.log(formattedData);

      const config = {
        method: "post",
        maxBodyLength: Infinity,
        url:
          "/admin/use_case_journey/" +
          this.formData.id,
        headers: {
          Authorization: "Bearer " + access_token, // Replace with the actual token
        },
        data: formattedData,
      };
      try {
        const response = await api[config.method](config.url);

        if (response.data?.message == "success") {
          await this.fetchusecaseList(); // Refresh banner list after deletion
          this.$swal({
            title: "Saved",
            text: "Your data has been Saved.",
            icon: "success",
          });
          this.closeModal();
        } else {
          this.$swal({
            title: "Error!",
            text: "There was an issue deleting the data.",
            icon: "error",
          });
        }
      } catch (error) {
        var err = error.response.data.message;
        this.$swal({
          title: "Error!",
          text: err,
          icon: "error",
        });
      }
    },
    validateInput(event) {
      const key = event.key;
      // Allow only digits and backspace
      if (!/[0-9\b]/.test(key)) {
        event.preventDefault();
      }
    },
    async moveUp(index, id) {
      
      if (index > 0) {
        [this.usecaseList[index - 1], this.usecaseList[index]] = [
          this.usecaseList[index],
          this.usecaseList[index - 1],
        ];

        // Trigger reactivity update
        this.usecaseList = [...this.usecaseList];
      }
      console.log({ index }, this.usecaseList[index], this.usecaseList.findIndex((data) => data.id ===id))
      const newIndex = this.usecaseList.findIndex((data) => data.id ===id);
      // return;

      let access_token = localStorage.getItem("access_token");

      const config = {
        method: "put",
        maxBodyLength: Infinity,
        url:
          "/admin/use_case_direction/" +
          id,
        headers: {
          Authorization: "Bearer " + access_token, // Replace with the actual token
        },
        data: {
          direction: newIndex + 1
        },
      };

      try {
        this.loading = true;

        await api.put(config.url, config.data);

        this.fetchusecaseList();
      } catch (error) {
        console.log({ error })
      }


    },

    async moveDown(index, id) {
      if (index < this.usecaseList.length - 1) {
        [this.usecaseList[index], this.usecaseList[index + 1]] = [
          this.usecaseList[index + 1],
          this.usecaseList[index],
        ];

        // Trigger reactivity update
        this.usecaseList = [...this.usecaseList];
      }
      const newIndex = this.usecaseList.findIndex((data) => data.id ===id);
      console.log({ index }, this.usecaseList[index], this.usecaseList, {newIndex})

      let access_token = localStorage.getItem("access_token");

      const config = {
        method: "put",
        maxBodyLength: Infinity,
        url:
          "/admin/use_case_direction/" +
          id,
        headers: {
          Authorization: "Bearer " + access_token, // Replace with the actual token
        },
        data: {
          direction: newIndex + 1
        },
      };

      try {
        this.loading = true;

        await api.put(config.url, config.data);

        this.fetchusecaseList();
      } catch (error) {
        console.log({ error })
      }


    },
  },
};
</script>
<style>
::v-deep .ql-editor strong {
  font-weight: bold;
}

::v-deep .ql-editor em {
  font-style: italic;
}

::v-deep .ql-editor strong em,
::v-deep .ql-editor em strong {
  font-weight: bold;
  font-style: italic;
}

/* Optional: Ensure modal is shown properly */
.modal.show {
  display: block;
  /* Override display to block */
}

.modal-backdrop {
  opacity: 50%;
}

.large-editor {
  height: 300px !important;
  /* Atur tinggi editor */
  width: 100%;
  /* Lebar menyesuaikan kontainer */
}

.large-editor .ql-container {
  min-height: 400px;
  /* Atur area konten */
}

.large-editor .ql-editor {
  font-size: 16px;
  /* Ukuran teks */
  padding: 16px;
  /* Ruang di dalam editor */
}

.custom-width-modal {
  max-width: 100% !important;
  margin-left: 17.125rem !important;
}

/* Gaya untuk grup radio dengan ikon */
.icon-radio-group {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}

.icon-radio {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}

.icon-radio input {
  display: none;
  /* Sembunyikan radio button asli */
}

.icon-radio img {
  width: 40px;
  height: 40px;
  border: 2px solid transparent;
  border-radius: 8px;
  transition: 0.3s;
}

.icon-radio input:checked+img {
  border-color: #007bff;
  /* Warna border untuk ikon terpilih */
  box-shadow: 0 0 8px rgba(0, 123, 255, 0.5);
}

.icon-radio span {
  margin-top: 8px;
  font-size: 12px;
  color: #333;
}
</style>
